/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { connect } from "react-redux";
import { selectDateFilter } from "../../../redux/actions/dateFilterAction";
import "./dateDetail.css";
import DateDetailPage from "./DateDetailPage";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  grid: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  tab: {
    marginLeft: theme.spacing(4),
  },
  picker: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "-15px",
    display: "flex",
  },
  title: {
    flexGrow: 1,
  },
}));

function DateDetailOperator(props) {
  const { history, cityFilter } = props;
  const isFirstRender = React.useRef(true);
  const classes = useStyles();

  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      history.push("/settlement-view");
    }
  }, [cityFilter]);

  return (
    <DateDetailPage {...{ ...props, componentType: "operator", useStyleClasses: classes }} />
  );
}

function mapStateToProps(state) {
  return {
    content: state.DateDue.dateDueBreakDown.items,
    totalItem: state.DateDue.dateDueBreakDown.totalItems,
    cityFilter: state.Cities.selectedCity,
    collectionLoader: state && state.loadingBar && state.loadingBar.collectionLoader,
    gridLoader: state && state.loadingBar && state.loadingBar.gridLoader,
    user: state.Auth.user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DateDetailOperator);
